import React, { useState } from 'react';
import { Box, TextV2, styled } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { useSubmitFormAnswers } from '../hooks/useSubmitFormAnswers';
import { EventForm } from '@shared/components/EventForm/components/data/EventForm';

type FormProps = {
  formId: string;
};

// Styled components for animation
export const AnimatedContainer = styled(Box)<{ $isVisible: boolean }>`
  width: 100%;
  height: 100%;
  max-height: ${({ $isVisible }) => ($isVisible ? '10000px' : '0px')};
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${({ $isVisible }) => ($isVisible ? '1' : '0')};
  pointer-events: ${({ $isVisible }) => ($isVisible ? 'auto' : 'none')};
  transition:
    opacity 0.5s ease,
    max-height 0.5s ease;
`;

export const Form = (type: FormProps) => {
  const { formId } = type;
  const { submitFormAnswers } = useSubmitFormAnswers();
  const [hasSubmitted, setHasSubmitted] = useState<false | 'skipped' | 'submitted'>(false);
  const { tq } = useTranslation('formCustomComponent');

  const onComplete = (answers: Record<string, unknown>) => {
    submitFormAnswers(formId, answers).then((response: { __typename?: string } | null) => {
      if (response) {
        setHasSubmitted('submitted');
      }
    });
  };

  return (
    <Box
      width="100%"
      marginTop="2rem"
    >
      {/* Confirmation Message */}
      <AnimatedContainer $isVisible={hasSubmitted !== false}>
        <TextV2
          typographyVariant="hed3"
          textAlign="center"
        >
          {hasSubmitted === 'submitted' ? tq`Form successfully submitted.` : tq`Your answer was not recorded`}
        </TextV2>
      </AnimatedContainer>

      {/* Form Renderer */}
      <AnimatedContainer $isVisible={!hasSubmitted}>
        <EventForm
          formId={formId}
          onComplete={onComplete}
        />
      </AnimatedContainer>
    </Box>
  );
};
